import React from "react";
import MonthlyClosuresTable from "../MonthlyClosuresTable";

const CLOSED_STATUS_ID = 3;

const DETAIL_ACTION = {
  className: "btn-gray-600",
  icon: "fa-eye",
  label: "Ver detalle",
  path: "/monthly-closing/close-months",
};

export default function ClosedMonths({ history, dataDoctor }) {
  return (
    <MonthlyClosuresTable
      tabId={2}
      statusId={CLOSED_STATUS_ID}
      action={DETAIL_ACTION}
      {...{ history, dataDoctor }}
    />
  );
}
